const queryCache = {};

export const getCacheValue = (key: string) => {
  return queryCache[key];
};

export const setCacheValue = (key: string, value: unknown) => {
  queryCache[key] = value;
};
